import { gql } from '@apollo/client'

export const GET_FABRIC_SETTINGS = gql`
  query GET_FABRIC_SETTINGS {
    findManySetting(
      where: {
        name: {
          in: [
            "fabric_stock_plenty_message"
            "fabric_stock_low_message"
            "fabric_low_stock_threshold"
          ]
        }
      }
    ) {
      name
      title
      type
      value
      shopSettingId
      description
      __typename
    }
  }
`

export const UPDATE_ONE_SETTING = gql`
  mutation UpdateOneSetting(
    $data: SettingUpdateInput!
    $where: SettingWhereUniqueInput!
  ) {
    updateOneSetting(data: $data, where: $where) {
      name
      value
      __typename
    }
  }
`
